// extracted by mini-css-extract-plugin
module.exports = {"head":"styles_head__1l3wc","title":"styles_title__3PEkX","topText":"styles_topText__3c-id","subtitle":"styles_subtitle__3MXE1","titleText":"styles_titleText__fgQlQ"};